const addSeasonModalStyles = {
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
  },
}

export default addSeasonModalStyles